class InternalOffice {
    id = null;
    name = '';
    address = '';
    postcode = '';
    town = '';
    country_id = null;
    oib = '';
    notes = '';
    phone = '';
    fax = '';
    vat = '';
    email = '';
    logo = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    active = true;
    office_footer = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default InternalOffice;
